// extracted by mini-css-extract-plugin
module.exports = {"with_card":"StartPage_with_card__2Bajd","logo":"StartPage_logo__1uRwr","page":"StartPage_page__1uR25","without_card":"StartPage_without_card__3O-xR"};